module.exports = __webpack_public_path__ + "img/llamadas.4cd02d35.svg";